import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
// import { FormGroup } from '@angular/forms'
import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { UntypedFormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { WindowComponent } from '@progress/kendo-angular-dialog';
import { CellTemplateDirective, ColumnComponent, GridComponent, KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_LABELS } from '@progress/kendo-angular-label';
import { MiddleService } from './middle.service';
import { PhonePipe } from '../../../@theme/pipes/phone.pipe';
@Component({
    selector: 'gd-label',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <kendo-label
      *ngIf="field.name === 'datesubmitted'" 
      [attr.for]="field.label" class="w-40 font-medium mr-2 space-y-4"
      style="font-size:12px"
    >
      {{ field.value | date : 'MM/dd/yyyy' }}
      <!--   h:mm:ss a -->
    </kendo-label>
    <kendo-label
      [attr.for]="field.label"
      *ngIf="field.name !== 'datesubmitted' && (field.name || '').toLowerCase() !== 'accountname'"
     class="w-40 font-medium mr-2 space-y-4"
      >{{ field.name === 'mobile' ? (field.value | phone) : field.value }}</kendo-label
    >
    <kendo-label
      [attr.for]="field.label"
      *ngIf="(field.name || '').toLowerCase() === 'accountname'"
     class="w-40 font-medium mr-2 space-y-4"
      (click)="onAccountNameClick($event)"
      [innerHTML]="trustHtml(accountNameDisplay())"></kendo-label
    >
    <kendo-label *ngIf="field.name === 'clientdob'" class="w-40 font-medium">
      - {{ getPrimaryAge() }}
    </kendo-label>
    <span class="w-40 font-medium mr-2 space-y-4" *ngIf="field.name === 'status'">
      <button
  type="button"
  (click)="openStatusHistory(blotId)"
  class="px-3 py-1.5 text-sm font-medium text-blue-600 dark:text-blue-400
         border border-blue-600 dark:border-blue-400
         rounded-md hover:bg-blue-50 dark:hover:bg-blue-900
         focus:outline-none focus:ring-2 focus:ring-blue-300
         transition-colors duration-200"
>
  View Status History
</button></span
    >
  
  <!-- Dark backdrop overlay -->
  <div *ngIf="opened" 
       style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.7); z-index: 10000;"
       (click)="close()">
  </div>

  <kendo-window
  *ngIf="opened"
  [width]="850"
  [resizable]="true"
  [draggable]="true"
  (close)="close()"
  [style.position]="'centered'"
  [style.top]="'50%'"
  [style.left]="'50%'"
  [style.transform]="'translate(-50%, -50%)'"
  [style.z-index]="'99999'"
  class="!fixed !isolate"
  [style.top]="'50%'"
  [style.left]="'50%'"
>
  <ng-template kendoWindowTitleBar>
    <div class="flex items-center gap-2">
      <span class="k-icon k-i-print"></span>
      <span>View Status History</span>
    </div>
  </ng-template>

  <kendo-grid
    [data]="stathistorylist"
    style="font-size: 10px"
    [nbSpinner]="!stathistorylist"
  >
    <kendo-grid-column [width]="50">
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="statusTypeDesc" title="StatusType Description"  [width]="170">
      <ng-template kendoGridCellTemplate let-column>
        <span style="font-size:10px">{{ column.statusTypeDesc }}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="modifiedBy" title="Modified by" [width]="150"></kendo-grid-column>

    <kendo-grid-column field="modifiedDate" title="Modified Date" [width]="150">
      <ng-template kendoGridCellTemplate let-column>
        <span style="font-size:10px">
          {{ column.modifiedDate | date : 'MM/dd/yyyy  h:mm:ss a' }}
        </span>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>

  <div class="mt-4 text-center">
    <button kendoButton (click)="close()" style="width: 100%">
      Close Window
    </button>
  </div>
</kendo-window>

  `,
    imports: [
      CommonModule,
        NgIf,
        KENDO_LABELS,
        WindowComponent,
        GridComponent,
        KENDO_GRID,
        ColumnComponent,
        CellTemplateDirective,
        ButtonComponent,
        DatePipe,
        PhonePipe,
    ]
})
export class LabelComponent {
  public loaderVisible = false
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  @Input() blotId: number
  windowPosition = { top: 50, left: 50 };
  public stathistorylist: any
  opened = false
  constructor(
    private gethistory: MiddleService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
  ) { }
  trustHtml(value: any): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value ?? '')
  }
  /* New transactions carry the ClientId as the value; show the matching account name instead */
  accountNameDisplay(): any {
    const match = (this.field.options || []).find(
      (o) => String(o.key) === String(this.field.value),
    )
    return match ? match.label : this.field.value
  }
  onAccountNameClick(event: MouseEvent): void {
    const target = event.target as HTMLElement
    const anchor = target?.closest('a') as HTMLAnchorElement | null
    if (anchor && (anchor.getAttribute('href') || '').indexOf('edit-account') !== -1) {
      sessionStorage.setItem('returnToTransactionUrl', window.location.href)
    }
  }
  setWindowPosition() {
    const windowWidth = 900;
    const estimatedHeight = 500;
  
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const viewportHeight = window.innerHeight;
  
    // Open near the **bottom of the viewport**, not document
    this.windowPosition = {
      top: scrollY + (viewportHeight - estimatedHeight - 40),
      left: (window.innerWidth - windowWidth) / 2
    };
  }
  openStatusHistory(b: number): void {
    this.setWindowPosition();
    this.opened = true
    setTimeout(() => {
      const winEl = document.querySelector('.k-window') as HTMLElement;
      if (winEl) {
        winEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
    this.loaderVisible = !this.loaderVisible
    if (b != 0) {
      this.gethistory.GetBlotterHistory(b).subscribe((relist) => {
        this.stathistorylist = relist
        this.loaderVisible = false
        this.cdr.detectChanges()
      })
    }
  }
  close() {
    this.opened = false
  }
  getPrimaryAge(): string {
    const dob = this.form.get('clientdob').value
    const years = this.calculateAge(new Date(dob))
    return years + 'yo'
  }
  calculateAge(date: Date): number {
    const millisecDifference = Date.now() - new Date(date).getTime()
    const millisecPerDay = 24 * 60 * 60 * 1000
    const millisecPerYear = 365.25 * millisecPerDay

    const yearDifference = Math.floor(millisecDifference / millisecPerYear)
    return yearDifference
  }
}
